// App.jsx - 메인 파일
import React from 'react';
import NotesMain from './notes/NotesMain';

interface NotesPageProps {
  id?: string;
  userInfo?: any;
  pboardName?: string;
  pbid?: string;
}

function NotesPage(props: NotesPageProps) {
  return (
    <div className="w-full min-h-screen">
      <NotesMain id={props.id} userInfo={props.userInfo} />
    </div>
  );
}

export default NotesPage;
